module.exports = __webpack_public_path__ + "img/Cucumis_sativus.72e275d0.jpg";